<template>
    <div class="paper-detail-container">
        <el-card class="header-card">
            <div class="header-content">
                <div class="header-left">
                    <el-button icon="el-icon-arrow-left" circle @click="goBack"></el-button>
                    <div class="title-section">
                        <h1 class="page-title">学案详情</h1>
                        <p class="subtitle">Paper Detail Information</p>
                    </div>
                </div>
                <div class="header-right">
                    <el-tag :type="getStatusType(paperInfo.paperStatus)" size="medium">
                        {{ getStatusText(paperInfo.paperStatus) }}
                    </el-tag>
                    <el-button
                        v-if="[1, 4, 5].includes(paperInfo.paperStatus)"
                        type="primary"
                        icon="el-icon-download"
                        @click="downloadPaper">
                        下载试卷
                    </el-button>
                </div>
            </div>
        </el-card>

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
            <div class="loading-spinner">
                <i class="el-icon-loading"></i>
                <p>加载中...</p>
            </div>
        </div>

        <!-- 试卷详情内容 -->
        <div v-else-if="paperInfo" class="detail-content">
            <!-- 生成异常补偿提示条（方案C：状态=生成异常时必显示，确保一定有补充入口） -->
            <el-alert
                v-if="paperInfo.paperStatus === 5 || paperInfo.paperStatus === '生成异常' || (missingTypes && missingTypes.length)"
                class="missing-types-alert"
                type="warning"
                :closable="false"
                show-icon>
                <div slot="title" class="missing-alert-title">
                    <span v-if="missingTypes && missingTypes.length">以下题型生成异常（AI 多次重试仍无有效结果，已自动跳过）：</span>
                    <span v-else>本卷生成异常（部分题型缺失），可点击右侧按钮重新生成缺失题型：</span>
                    <el-tag
                        v-for="t in missingTypes"
                        :key="t"
                        size="mini"
                        type="warning"
                        effect="plain"
                        class="missing-tag">{{ t }}</el-tag>
                    <el-button
                        class="missing-regenerate-btn"
                        type="warning"
                        size="mini"
                        icon="el-icon-refresh"
                        :loading="regenerating"
                        @click="handleRegenerateMissing">重新生成缺失题型</el-button>
                </div>
                <div class="missing-alert-detail">
                    <div v-for="(item, idx) in missingDetail" :key="idx" class="missing-detail-item">
                        <strong>{{ item.typeName }}</strong>：缺少 {{ item.missingCount }} 篇（目标 {{ item.target }} 篇，实际 {{ item.actual }} 篇）
                        <span class="missing-reason">原因：{{ item.reason }}</span>
                    </div>
                    <div v-if="!missingDetail || !missingDetail.length" class="missing-detail-item">
                        未记录到具体缺失明细，将按本卷选题配置重新生成全部 AI 题型。
                    </div>
                </div>
            </el-alert>


            <!-- 基本信息卡片 -->
            <el-row :gutter="20" class="info-row">
                <el-col :span="16">
                    <el-card class="info-card" shadow="hover">
                        <div slot="header" class="card-header">
                            <i class="el-icon-document"></i>
                            <span>基本信息</span>
                        </div>
                        <el-descriptions :column="2" border>
                            <el-descriptions-item label="试卷ID">
                                <span class="value-text">{{ paperInfo.id }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="学生姓名">
                                <span class="value-text">{{ paperInfo.studentName }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="创建时间">
                                <span class="value-text">{{ paperInfo.createTime }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="提交时间">
                                <span class="value-text">{{ paperInfo.submitTime || '未提交' }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="批改时间">
                                <span class="value-text">{{ paperInfo.gradeTime || '未批改' }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="起始单词ID">
                                <span class="value-text">{{ paperInfo.startWordId }}</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card class="stats-card" shadow="hover">
                        <div slot="header" class="card-header">
                            <i class="el-icon-data-analysis"></i>
                            <span>统计信息</span>
                        </div>
                        <div class="stats-grid">
                            <div class="stat-item">
                                <div class="stat-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                                    <i class="el-icon-tickets"></i>
                                </div>
                                <div class="stat-info">
                                    <div class="stat-label">总题数</div>
                                    <div class="stat-value">{{ paperInfo.totalWords }}</div>
                                </div>
                            </div>
                            <div class="stat-item">
                                <div class="stat-icon" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);">
                                    <i class="el-icon-star-on"></i>
                                </div>
                                <div class="stat-info">
                                    <div class="stat-label">总分</div>
                                    <div class="stat-value">{{ paperInfo.totalScore }}</div>
                                </div>
                            </div>
<!--                            <div class="stat-item">-->
<!--                                <div class="stat-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">-->
<!--                                    <i class="el-icon-medal"></i>-->
<!--                                </div>-->
<!--                                <div class="stat-info">-->
<!--                                    <div class="stat-label">得分</div>-->
<!--                                    <div class="stat-value score-highlight">{{ paperInfo.score || '-' }}</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="stat-item">-->
<!--                                <div class="stat-icon" style="background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);">-->
<!--                                    <i class="el-icon-medal-1"></i>-->
<!--                                </div>-->
<!--                                <div class="stat-info">-->
<!--                                    <div class="stat-label">正确率</div>-->
<!--                                    <div class="stat-value">-->
<!--                                        {{ paperInfo.score && paperInfo.totalScore ? Math.round((paperInfo.score / paperInfo.totalScore) * 100) + '%' : '-' }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <!-- 题型分布（悬浮导航） -->
            <div class="question-types-nav" :class="{ 'is-sticky': navSticky }" ref="navBar">
                <el-card class="question-types-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <i class="el-icon-s-grid"></i>
                        <span>题型分布 — 点击快速跳转</span>
                        <span class="header-badge">{{ totalQuestions }} 题</span>
                    </div>
                    <el-row :gutter="15">
                        <el-col :span="8" v-for="(item, index) in questionTypes" :key="index">
                            <div class="question-type-card" :class="{ 'type-active': activeSection === index }"
                                 @click="scrollToSection(index)">
                                <div class="type-icon" :style="{ background: item.color }">
                                    <i :class="item.icon"></i>
                                </div>
                                <div class="type-info">
                                    <div class="type-name">{{ item.name }}</div>
                                    <div class="type-count">{{ item.count }} 题</div>
                                    <el-progress
                                        :percentage="getQuestionPercentage(item.count)"
                                        :show-text="false"
                                        :stroke-width="6"
                                        :color="item.color">
                                    </el-progress>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

            <!-- 高频生词表 -->
            <el-card :id="'section-0'" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-notebook-2"></i>
                    <span>高频生词表</span>
                    <span class="header-badge">{{ vocabularyData.length }} 个单词</span>
                </div>
                <el-table :data="vocabularyData" border style="width: 100%" class="vocabulary-table">
                    <el-table-column type="index" label="#" width="60" align="center"></el-table-column>
                    <el-table-column prop="word" label="单词" width="150">
                        <template slot-scope="scope">
                            <span class="word-text">{{ scope.row.word }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phonetic_uk" label="英式音标" width="150">
                        <template slot-scope="scope">
                            <span class="phonetic-text">{{ scope.row.phonetic_uk }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phonetic_us" label="美式音标" width="150">
                        <template slot-scope="scope">
                            <span class="phonetic-text">{{ scope.row.phonetic_us }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="chinese_meaning" label="中文含义" min-width="200">
                        <template slot-scope="scope">
                            <span class="meaning-text">{{ scope.row.chinese_meaning }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="part_of_speech" label="词性" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag size="small" type="info">{{ scope.row.part_of_speech }}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>

            <!-- SuperMemo速记卡片 -->
            <el-card :id="'section-1'" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-collection"></i>
                    <span>SuperMemo速记</span>
                    <span class="header-badge">{{ superMemoData.length }} 张卡片</span>
                </div>
                <div class="memo-grid">
                    <div v-for="(card, index) in superMemoData" :key="index" class="memo-grid-item">
                        <div class="memo-card">
                            <div class="memo-front">
                                <div class="memo-content">{{ card.chineseMeaning }}</div>
                            </div>
                            <div class="memo-arrow">
                                <i class="el-icon-right"></i>
                            </div>
                            <div class="memo-back">
                                <div class="memo-content">{{ card.word }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>

            <!-- 例句练习表 -->
            <el-card :id="'section-2'" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-chat-line-square"></i>
                    <span>例句练习</span>
                    <span class="header-badge">{{ sentencesData.length }} 个例句</span>
                </div>
                <div v-for="(sentence, index) in sentencesData" :key="index" class="sentence-item">
                    <div class="sentence-number">{{ index + 1 }}</div>
                    <div class="sentence-content">
                        <div class="sentence-en">{{ sentence.english }}</div>
                        <div class="sentence-cn">{{ sentence.chinese }}</div>
                        <div v-if="sentence.analysis" class="sentence-analysis">
                            <i class="el-icon-info"></i>
                            <span>{{ sentence.analysis }}</span>
                        </div>
                    </div>
                </div>
            </el-card>

            <!-- 语境语感训练 -->
            <el-card v-if="contextSensitivityData.length > 0" :id="'section-4'" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-reading"></i>
                    <span>语境语感训练</span>
                    <span class="header-badge">{{ contextSensitivityData.length }} 篇文章</span>
                </div>
                <div v-for="(reading, rIndex) in contextSensitivityData" :key="rIndex" class="reading-item">
                    <div class="reading-header">
                        <h3>Passage {{ rIndex + 1 }}: {{ reading.title }}</h3>
                    </div>
                    <div class="reading-content">
                        <div class="article-section">
                            <h4>📖 英文原文</h4>
                            <div class="article-text" v-html="reading.content"></div>
                        </div>
                        <div class="translation-section">
                            <h4>📝 中文翻译</h4>
                            <div class="article-text translation-text">{{ reading.translation }}</div>
                        </div>
                        <div class="questions-section">
                            <h4>❓ 问题与答案</h4>
                            <div v-if="reading.questions.length === 0" style="color: #909399; padding: 10px;">暂无题目数据</div>
                            <div v-for="(question, qIndex) in reading.questions" :key="qIndex" class="question-item">
                                <div class="question-header">
                                    <span class="question-num">Question {{ qIndex + 1 }}</span>
                                    <el-tag size="mini" type="success">答案: {{ question.correct_answer }}</el-tag>
                                </div>
                                <div class="question-text">{{ question.question_en }}</div>
                                <div class="options-list">
                                    <div v-for="option in question.options" :key="option.option"
                                         class="option-item"
                                         :class="{ 'correct-option': option.option === question.correct_answer }">
                                        <span class="option-label">{{ option.option }}.</span>
                                        <span class="option-content">{{ option.content_en }}</span>
                                        <i v-if="option.option === question.correct_answer" class="el-icon-check correct-icon"></i>
                                    </div>
                                </div>
                                <div class="question-analysis">
                                    <i class="el-icon-light-bulb"></i>
                                    <strong>解析：</strong>{{ question.analysis_cn }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>

            <!-- 好词好句 -->
            <el-card :id="'section-3'" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-star-on"></i>
                    <span>好词好句</span>
                    <span class="header-badge">{{ goodWordSentenceData.length }} 个好句</span>
                </div>
                <div v-if="goodWordSentenceData.length === 0" style="padding: 20px; text-align: center; color: #909399;">
                    暂无好词好句数据
                </div>
                <div v-for="(item, index) in goodWordSentenceData" :key="index" class="good-word-item">
                    <div class="good-word-header">
                        <i class="el-icon-star-on header-icon"></i>
                        <span class="good-word-label">好词好句 #{{ index + 1 }}</span>
                    </div>
                    <div class="good-word-body">
                        <div class="gw-row">
                            <span class="gw-label">英文佳句</span>
                            <div class="gw-text gw-en">{{ item.english }}</div>
                        </div>
                        <div class="gw-row">
                            <span class="gw-label">中文翻译</span>
                            <div class="gw-text gw-cn">{{ item.chinese }}</div>
                        </div>
                        <div v-if="item.analysis" class="gw-row">
                            <span class="gw-label">句子解析</span>
                            <div class="gw-analysis">{{ item.analysis }}</div>
                        </div>
                    </div>
                </div>
            </el-card>

            <!-- 选词填空 -->
            <el-card :id="'section-5'" v-if="wordFillData.length > 0" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-document"></i>
                    <span>选词填空</span>
                    <span class="header-badge">{{ wordFillData.length }} 篇</span>
                </div>
                <div v-for="(wf, wIndex) in wordFillData" :key="wIndex" class="fill-section">
                    <div class="fill-header">
                        <h4>选词填空 #{{ wIndex + 1 }}</h4>
                    </div>
                    <div class="word-box">
                        <span class="word-box-label">请选用以下单词的适当形式填空：</span>
                        <div class="word-box-tags">
                            <el-tag v-for="(word, wbIndex) in wf.wordBox" :key="wbIndex" class="word-box-tag" type="warning">
                                {{ word }}
                            </el-tag>
                        </div>
                    </div>
                    <div class="fill-passage">
                        <div class="passage-text" v-html="wf.passage"></div>
                    </div>
                    <div v-if="wf.answers.length > 0" class="fill-answers">
                        <h4>参考答案</h4>
                        <div v-for="(ans, aIndex) in wf.answers" :key="aIndex" class="answer-item">
                            <span class="answer-blank">第{{ ans.blank }}空</span>
                            <span class="answer-base">{{ ans.base_word }}</span>
                            <el-tag size="small" type="success">{{ ans.correct_form }}</el-tag>
                            <span v-if="ans.analysis" class="answer-analysis">{{ ans.analysis }}</span>
                        </div>
                    </div>
                    <div v-if="wf.translation" class="fill-translation">
                        <h4>全文翻译</h4>
                        <div class="translation-text">{{ wf.translation }}</div>
                    </div>
                </div>
            </el-card>

            <!-- 短文填空 -->
            <el-card :id="'section-6'" v-if="passageFillData.length > 0" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-edit-outline"></i>
                    <span>短文填空</span>
                    <span class="header-badge">{{ passageFillData.length }} 篇</span>
                </div>
                <div v-for="(pf, pIndex) in passageFillData" :key="pIndex" class="fill-section">
                    <div class="fill-header">
                        <h4>短文填空 #{{ pIndex + 1 }}</h4>
                    </div>
                    <div class="fill-passage">
                        <div class="passage-text" v-html="pf.passage"></div>
                    </div>
                    <div v-if="pf.blanks.length > 0" class="blanks-table">
                        <h4>填空提示与答案</h4>
                        <el-table :data="pf.blanks" border size="small">
                            <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
                            <el-table-column prop="index" label="题号" width="80" align="center"></el-table-column>
                            <el-table-column prop="type" label="提示类型" width="120" align="center">
                                <template slot-scope="scope">
                                    <el-tag size="mini" :type="scope.row.type === 'none' ? 'info' : 'warning'">
                                        {{ {first_letter:'首字母',chinese:'中文提示',phonetic:'音标',word_transform:'词形变化',none:'无提示'}[scope.row.type] || scope.row.type }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="hint" label="提示内容" width="150"></el-table-column>
                            <el-table-column prop="answer" label="答案" width="120">
                                <template slot-scope="scope">
                                    <el-tag size="small" type="success">{{ scope.row.answer }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="explanation" label="解析" min-width="200"></el-table-column>
                        </el-table>
                    </div>
                    <div v-if="pf.translation" class="fill-translation">
                        <h4>全文翻译</h4>
                        <div class="translation-text">{{ pf.translation }}</div>
                    </div>
                </div>
            </el-card>

            <!-- 任务型阅读 -->
            <el-card :id="'section-7'" v-if="taskReadingData.length > 0" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-tickets"></i>
                    <span>任务型阅读</span>
                    <span class="header-badge">{{ taskReadingData.length }} 篇</span>
                </div>
                <div v-for="(tr, tIndex) in taskReadingData" :key="tIndex" class="reading-item">
                    <div class="reading-header">
                        <h3>Task {{ tIndex + 1 }}: {{ tr.title }}</h3>
                    </div>
                    <div class="reading-content">
                        <div class="article-section">
                            <div class="article-text" v-html="tr.content"></div>
                        </div>
                        <div v-if="tr.taskData" class="task-section">
                            <div class="task-header">
                                <el-tag size="medium" type="primary">
                                    {{ {table_completion:'表格填空',sentence_completion:'完成句子',summary_completion:'摘要填空'}[tr.taskData.taskType] || tr.taskData.taskType || '任务' }}
                                </el-tag>
                                <span class="task-instruction">{{ tr.taskData.instruction }}</span>
                            </div>
                            <div v-if="tr.taskData.tasks" class="task-list">
                                <div v-for="(task, taskIndex) in tr.taskData.tasks" :key="taskIndex" class="task-item">
                                    <div class="task-question">
                                        <span class="task-num">{{ task.id }}.</span>
                                        <span>{{ task.question }}</span>
                                    </div>
                                    <div class="task-answer">
                                        <span class="task-answer-label">答案：</span>
                                        <el-tag size="small" type="success">{{ task.answer }}</el-tag>
                                        <span v-if="task.constraint" class="task-constraint">({{ task.constraint }})</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="tr.translation" class="translation-section">
                            <h4>中文翻译</h4>
                            <div class="article-text translation-text">{{ tr.translation }}</div>
                        </div>
                    </div>
                </div>
            </el-card>

            <!-- 完形填空 -->
            <el-card :id="'section-8'" v-if="clozeTestData.length > 0" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-s-order"></i>
                    <span>完形填空</span>
                    <span class="header-badge">{{ clozeTestData.length }} 篇</span>
                </div>
                <div v-for="(ct, cIndex) in clozeTestData" :key="cIndex" class="cloze-section">
                    <div class="cloze-header">
                        <h4>完形填空 #{{ cIndex + 1 }}</h4>
                    </div>
                    <div class="cloze-passage">
                        <div class="passage-text" v-html="ct.passage"></div>
                    </div>
                    <div v-if="ct.questions.length > 0" class="cloze-questions">
                        <h4>题目与选项</h4>
                        <div v-for="(q, qIndex) in ct.questions" :key="qIndex" class="cloze-question-item">
                            <div class="cloze-q-header">
                                <span class="cloze-q-num">({{ q.blank_index }})</span>
                                <el-tag size="mini" type="success">答案: {{ q.correct }}</el-tag>
                            </div>
                            <div class="cloze-options">
                                <div v-for="opt in q.options" :key="opt.option"
                                     class="cloze-option"
                                     :class="{ 'correct-option': opt.option === q.correct }">
                                    <span class="cloze-opt-label">{{ opt.option }}.</span>
                                    <span>{{ opt.content }}</span>
                                    <i v-if="opt.option === q.correct" class="el-icon-check correct-icon"></i>
                                </div>
                            </div>
                            <div v-if="q.analysis" class="question-analysis">
                                <i class="el-icon-light-bulb"></i>
                                <strong>解析：</strong>{{ q.analysis }}
                            </div>
                        </div>
                    </div>
                    <div v-if="ct.translation" class="fill-translation">
                        <h4>全文翻译</h4>
                        <div class="translation-text">{{ ct.translation }}</div>
                    </div>
                </div>
            </el-card>

            <!-- 补全对话 -->
            <el-card :id="'section-9'" v-if="dialogueCompletionData.length > 0" class="content-card" shadow="hover">
                <div slot="header" class="card-header">
                    <i class="el-icon-chat-dot-round"></i>
                    <span>补全对话</span>
                    <span class="header-badge">{{ dialogueCompletionData.length }} 篇</span>
                </div>
                <div v-for="(dc, dIndex) in dialogueCompletionData" :key="dIndex" class="dialogue-section">
                    <div class="dialogue-header">
                        <h4>补全对话 #{{ dIndex + 1 }}</h4>
                        <div v-if="dc.scene" class="dialogue-scene">
                            <el-tag size="small" type="info">场景：{{ dc.scene }}</el-tag>
                        </div>
                    </div>
                    <div class="dialogue-lines">
                        <div v-for="(line, lIndex) in dc.dialogue" :key="lIndex" class="dialogue-line">
                            <span class="dialogue-speaker">{{ line.speaker }}：</span>
                            <span class="dialogue-text">{{ line.line }}</span>
                        </div>
                    </div>
                    <div v-if="dc.options.length > 0" class="dialogue-options-section">
                        <h4>选项</h4>
                        <div class="dialogue-options">
                            <div v-for="(opt, oIndex) in dc.options" :key="oIndex" class="dialogue-opt-item">
                                <span class="dialogue-opt-label">{{ opt.option || oIndex + 1 }}.</span>
                                <span>{{ opt.content || opt }}</span>
                            </div>
                        </div>
                        <div v-if="dc.extra" class="dialogue-extra">
                            <el-tag size="small" type="warning">多余选项：{{ dc.extra }}</el-tag>
                        </div>
                    </div>
                    <div v-if="dc.answers.length > 0" class="dialogue-answers">
                        <h4>参考答案</h4>
                        <div v-for="(ans, aIndex) in dc.answers" :key="aIndex" class="answer-item">
                            <span class="answer-blank">第{{ ans.blank }}空</span>
                            <el-tag size="small" type="success">{{ ans.correct }}</el-tag>
                        </div>
                    </div>
                    <div v-if="dc.translation" class="fill-translation">
                        <h4>对话翻译</h4>
                        <div class="translation-text">{{ dc.translation }}</div>
                    </div>
                </div>
            </el-card>
        </div>

        <!-- 空状态 -->
        <el-empty v-else description="未找到试卷信息"></el-empty>
        <!-- 回到顶部 -->
        <el-backtop :visibility-height="400" :right="30" :bottom="60" />
    </div>
</template>

<script>
import global from "@/api/global"
import {getPaperDetail, getPaperQuestions, downloadPaperStream, regeneratePaperTypes} from '@/api/education/assessment'

export default {
    name: 'PaperDetail',
    data() {
        return {
            paperId: null,
            paperInfo: {},
            paperContent: {},
            loading: false,
            questionTypes: [
                { name: '高频生词表', count: 0, icon: 'el-icon-notebook-2', color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
                { name: 'SuperMemo速记', count: 0, icon: 'el-icon-collection', color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' },
                { name: '例句练习', count: 0, icon: 'el-icon-chat-line-square', color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' },
                { name: '好词好句', count: 0, icon: 'el-icon-star-on', color: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' },
                { name: '语境语感训练', count: 0, icon: 'el-icon-reading', color: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' },
                { name: '选词填空', count: 0, icon: 'el-icon-document', color: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)' },
                { name: '短文填空', count: 0, icon: 'el-icon-edit-outline', color: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)' },
                { name: '任务型阅读', count: 0, icon: 'el-icon-tickets', color: 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)' },
                { name: '完形填空', count: 0, icon: 'el-icon-s-order', color: 'linear-gradient(135deg, #fddb92 0%, #d1fdff 100%)' },
                { name: '补全对话', count: 0, icon: 'el-icon-chat-dot-round', color: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)' }
            ],
            // 从后端获取的数据
            vocabularyData: [],
            superMemoData: [],
            sentencesData: [],
            readingsData: [],
            goodWordSentenceData: [],
            contextSensitivityData: [],
            wordFillData: [],
            passageFillData: [],
            taskReadingData: [],
            clozeTestData: [],
            dialogueCompletionData: [],
            navSticky: false,
            activeSection: -1,
            // 方案C：生成缺失题型（AI 多次重试仍失败被跳过的题型名）
            missingTypes: [],
            // 方案C：生成缺失结构化明细（含每题型缺失篇数、原因）
            missingDetail: [],
            regenerating: false
        }
    },
    computed: {
        totalQuestions() {
            return this.questionTypes.reduce((sum, item) => sum + item.count, 0)
        }
    },
    created() {
        this.paperId = this.$route.params.id
        if (this.paperId) {
            this.loadPaperDetail()
        } else {
            this.$message.error('缺少试卷ID参数')
            this.goBack()
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.setupScrollObserver()
        })
    },
    beforeDestroy() {
        this.scrollObserver && this.scrollObserver.disconnect()
    },
    methods: {
        setupScrollObserver() {
            const nav = this.$refs.navBar
            if (!nav) return
            const navTop = nav.offsetTop
            window.addEventListener('scroll', () => {
                this.navSticky = window.scrollY > navTop - 10
            })

            // 使用 IntersectionObserver 高亮当前可见题型
            const sections = []
            for (let i = 0; i <= 9; i++) {
                const el = document.getElementById('section-' + i)
                if (el) sections.push(el)
            }
            if (sections.length === 0) return
            this.scrollObserver = new IntersectionObserver((entries) => {
                let maxRatio = 0
                let maxIdx = this.activeSection
                entries.forEach(entry => {
                    const idx = parseInt(entry.target.id.replace('section-', ''))
                    if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
                        maxRatio = entry.intersectionRatio
                        maxIdx = idx
                    }
                })
                if (maxRatio > 0) this.activeSection = maxIdx
            }, { threshold: [0, 0.25, 0.5, 0.75, 1] })
            sections.forEach(el => this.scrollObserver.observe(el))
        },
        scrollToSection(index) {
            const el = document.getElementById('section-' + index)
            if (el) {
                const navHeight = this.$refs.navBar ? this.$refs.navBar.offsetHeight + 15 : 80
                const top = el.getBoundingClientRect().top + window.scrollY - navHeight
                window.scrollTo({ top, behavior: 'smooth' })
                this.activeSection = index
            }
        },
        // 加载试卷详情
        async loadPaperDetail() {
            this.loading = true
            try {
                // 1. 加载试卷基本信息
                const res = await getPaperDetail(this.paperId)
                this.paperInfo = res.data || res

                // 2. 加载试卷完整内容（按题型分组的新接口）
                await this.loadPaperContent()

            } catch (error) {
                console.error('加载试卷详情失败:', error)
                this.$message.error('加载试卷详情失败')
            } finally {
                this.loading = false
            }
        },

        // 加载试卷完整内容（新接口：/education/exam/paper/content）
        async loadPaperContent() {
            try {
                const res = await getPaperQuestions(this.paperId)
                const content = res.data || res || {}
                console.log('试卷内容数据:', content)

                // 填充试卷补充信息（来自 PaperContentVO 的字段）
                if (content.paperNo) this.paperInfo.paperNo = content.paperNo
                if (content.paperTitle) this.paperInfo.paperTitle = content.paperTitle
                if (content.totalScore !== undefined) this.paperInfo.totalScore = content.totalScore
                if (content.passingScore !== undefined) this.paperInfo.passingScore = content.passingScore
                // 保留 detail API 返回的数字状态（用于控制下载按钮显隐），不覆盖

                // 直接映射各题型数据
                this.populateFromPaperContent(content)

            // 方案C：生成缺失题型提示列表 + 结构化缺失明细（含缺失篇数、原因）
            this.missingTypes = content.missingTypes || []
            this.missingDetail = this.parseMissingInfo(content.missingInfo)

            } catch (error) {
                console.error('加载试卷内容失败:', error)
                this.$message.error('加载试卷内容失败')
            }
        },

        // 将 PaperContentVO 数据填充到页面各展示区域
        populateFromPaperContent(content) {
            // 1. 高频生词表 (questionType=1)
            const highFreqVocab = content.highFreqVocab || []
            this.vocabularyData = highFreqVocab.map(item => ({
                word: item.word || '',
                phonetic_uk: item.phoneticUk || '',
                phonetic_us: item.phoneticUs || '',
                part_of_speech: item.partOfSpeech || '',
                chinese_meaning: item.chineseMeaning || ''
            }))

            // 2. SuperMemo速记 (questionType=2) — 已拍平为 word/collocation/wordForm 三条一组
            this.superMemoData = content.superMemo || []

            // 3. 例句练习 (questionType=3)
            const sentenceExercises = content.sentenceExercises || []
            this.sentencesData = sentenceExercises.map(item => {
                let english = ''
                let chinese = ''
                let analysis = ''
                if (item.extensionContentSnapshot) {
                    try {
                        const ext = JSON.parse(item.extensionContentSnapshot)
                        english = ext.content || ext.sentence || ''
                        chinese = item.extensionTranslationSnapshot || ext.translation || ''
                        analysis = item.answerAnalysisSnapshot || ext.answerAnalysis || ext.analysis || ''
                    } catch (e) {
                        english = item.extensionContentSnapshot || ''
                        chinese = item.extensionTranslationSnapshot || ''
                        analysis = item.answerAnalysisSnapshot || ''
                    }
                }
                return { english, chinese, analysis }
            }).filter(item => item.english || item.chinese)

            // 4. 好词好句 (questionType=4)
            const goodWordSentence = content.goodWordSentence || []
            this.goodWordSentenceData = goodWordSentence.map(item => {
                let english = ''
                let chinese = ''
                let analysis = ''
                if (item.extensionContentSnapshot) {
                    try {
                        const ext = JSON.parse(item.extensionContentSnapshot)
                        english = ext.content || ext.sentence || ''
                        chinese = item.extensionTranslationSnapshot || ext.translation || ''
                        analysis = item.answerAnalysisSnapshot || ext.answerAnalysis || ext.analysis || ''
                    } catch (e) {
                        english = item.extensionContentSnapshot || ''
                        chinese = item.extensionTranslationSnapshot || ''
                        analysis = item.answerAnalysisSnapshot || ''
                    }
                }
                return { english, chinese, analysis }
            }).filter(item => item.english || item.chinese)

            // 5. 语境语感训练 (questionType=5) — 阅读文章+选择题
            const contextSensitivity = content.contextSensitivity || []
            // 收集高频生词表的单词（用于加粗展示）
            const paperWords = [...new Set((content.highFreqVocab || []).map(item => item.word).filter(Boolean))]
            this.contextSensitivityData = contextSensitivity.map(item => {
                let title = 'Reading'
                let articleContent = ''
                let translation = ''
                let questions = []

                const rawContent = item.extensionContentSnapshot || item.questionContent || ''
                if (rawContent) {
                    const titleMatch = rawContent.match(/【(.+?)】/)
                    title = titleMatch ? titleMatch[1] : 'Reading'
                    articleContent = rawContent.replace(/【.+?】\n?/, '')
                }

                translation = item.extensionTranslationSnapshot || ''

                if (item.options) {
                    try {
                        const parsed = typeof item.options === 'string' ? JSON.parse(item.options) : item.options
                        if (Array.isArray(parsed)) {
                            questions = parsed
                        } else if (parsed && typeof parsed === 'object') {
                            questions = [parsed]
                        }
                    } catch (e) {
                        console.warn('语境语感训练题目解析失败', e)
                    }
                }

                // 将试卷中的单词在短文中加粗展示
                if (articleContent && paperWords.length > 0) {
                    let bolded = articleContent
                    paperWords.forEach(w => {
                        const escaped = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                        const regex = new RegExp('\\b(' + escaped + ')\\b', 'gi')
                        bolded = bolded.replace(regex, '<b>$1</b>')
                    })
                    articleContent = bolded
                }

                return { title, content: articleContent, translation, questions }
            })

            // 6. 选词填空 (questionType=6)
            const wordFill = content.wordFill || []
            this.wordFillData = wordFill.map(item => {
                let passage = item.questionContent || item.extensionContentSnapshot || ''
                let wordBox = []
                let answers = []

                if (item.options) {
                    try {
                        const parsed = typeof item.options === 'string' ? JSON.parse(item.options) : item.options
                        if (Array.isArray(parsed)) {
                            wordBox = parsed
                        }
                    } catch (e) {}
                }

                if (item.answerAnalysisSnapshot) {
                    try {
                        const parsed = JSON.parse(item.answerAnalysisSnapshot)
                        if (Array.isArray(parsed)) answers = parsed
                    } catch (e) {}
                }

                const translation = item.extensionTranslationSnapshot || ''
                return { passage, wordBox, answers, translation }
            })

            // 7. 短文填空 (questionType=7)
            const passageFill = content.passageFill || []
            this.passageFillData = passageFill.map(item => {
                const passage = item.questionContent || item.extensionContentSnapshot || ''
                let blanks = []

                if (item.options) {
                    try {
                        const parsed = typeof item.options === 'string' ? JSON.parse(item.options) : item.options
                        if (Array.isArray(parsed)) blanks = parsed
                    } catch (e) {}
                }

                const translation = item.extensionTranslationSnapshot || ''
                return { passage, blanks, translation }
            })

            // 8. 任务型阅读 (questionType=8)
            const taskReading = content.taskReading || []
            this.taskReadingData = taskReading.map(item => {
                let title = 'Task Reading'
                let articleContent = ''
                let translation = ''
                let taskData = null

                const rawContent = item.extensionContentSnapshot || item.questionContent || ''
                if (rawContent) {
                    const titleMatch = rawContent.match(/【(.+?)】/)
                    title = titleMatch ? titleMatch[1] : 'Task Reading'
                    articleContent = rawContent.replace(/【.+?】\n?/, '')
                }

                translation = item.extensionTranslationSnapshot || ''

                if (item.taskReadingData) {
                    taskData = item.taskReadingData
                }

                return { title, content: articleContent, translation, taskData }
            })

            // 9. 完形填空 (questionType=9)
            const clozeTest = content.clozeTest || []
            this.clozeTestData = clozeTest.map(item => {
                const passage = item.questionContent || item.extensionContentSnapshot || ''
                let questions = []

                if (item.options) {
                    try {
                        const parsed = typeof item.options === 'string' ? JSON.parse(item.options) : item.options
                        if (Array.isArray(parsed)) {
                            questions = parsed.map(q => {
                                if (q.options && Array.isArray(q.options)) {
                                    q.options = q.options.map(opt => {
                                        if (typeof opt === 'string') {
                                            const label = opt.charAt(0)
                                            const content = opt.substring(2).trim()
                                            return { option: label, content: content }
                                        }
                                        return opt
                                    })
                                }
                                return q
                            })
                        }
                    } catch (e) {}
                }

                const translation = item.extensionTranslationSnapshot || ''
                const analysis = item.answerAnalysisSnapshot || ''
                return { passage, questions, translation, analysis }
            })

            // 10. 补全对话 (questionType=10)
            const dialogueCompletion = content.dialogueCompletion || []
            this.dialogueCompletionData = dialogueCompletion.map(item => {
                if (item.dialogueCompletionData) {
                    const dcd = item.dialogueCompletionData
                    return {
                        scene: dcd.scene || '',
                        dialogue: dcd.dialogue || [],
                        options: dcd.options || [],
                        extra: dcd.extra || '',
                        answers: dcd.answers || [],
                        translation: dcd.translation || ''
                    }
                }
                const rawContent = item.extensionContentSnapshot || item.questionContent || ''
                let scene = ''
                let dialogue = []
                let options = []
                let extra = ''
                let answers = []

                if (rawContent) {
                    const sceneMatch = rawContent.match(/场景：(.+?)(?:\n|$)/)
                    scene = sceneMatch ? sceneMatch[1] : ''
                    const dialogueMatch = rawContent.replace(/场景：.+?\n/, '')
                    try {
                        dialogue = JSON.parse(dialogueMatch)
                    } catch (e) {}
                }

                if (item.options) {
                    try {
                        const parsed = typeof item.options === 'string' ? JSON.parse(item.options) : item.options
                        if (parsed.options) options = parsed.options
                        if (parsed.extra) extra = parsed.extra
                        if (parsed.answers) answers = parsed.answers
                    } catch (e) {}
                }

                const translation = item.extensionTranslationSnapshot || ''
                return { scene, dialogue, options, extra, answers, translation }
            })

            // 更新题型分布计数（按 questionTypes 的顺序）
            this.questionTypes[0].count = this.vocabularyData.length      // 高频生词表
            this.questionTypes[1].count = this.superMemoData.length        // SuperMemo
            this.questionTypes[2].count = this.sentencesData.length        // 例句练习
            this.questionTypes[3].count = this.goodWordSentenceData.length // 好词好句
            this.questionTypes[4].count = this.contextSensitivityData.length // 语境语感
            this.questionTypes[5].count = this.wordFillData.length         // 选词填空
            this.questionTypes[6].count = this.passageFillData.length      // 短文填空
            this.questionTypes[7].count = this.taskReadingData.length      // 任务型阅读
            this.questionTypes[8].count = this.clozeTestData.length        // 完形填空
            this.questionTypes[9].count = this.dialogueCompletionData.length // 补全对话

            this.readingsData = this.contextSensitivityData
        },

        // 方案C：重新生成缺失题型（仅对缺失列表对应的题型发起补偿生成，追加到已有试卷）
        async handleRegenerateMissing() {
            let types = []
            if (this.missingTypes && this.missingTypes.length) {
                // 优先用缺失明细里的题型名映射
                const nameToCode = {
                    '高频生词表': 1, 'SuperMemo速记': 2, '例句练习': 3, '好词好句': 4,
                    '语境语感训练': 5, '选词填空': 6, '短文填空': 7, '任务型阅读': 8,
                    '完形填空': 9, '补全对话': 10
                }
                types = this.missingTypes
                    .map(name => nameToCode[name])
                    .filter(code => code !== undefined)
            }
            // 兜底：missingTypes 为空（老数据/未记录明细）但状态为生成异常时，
            // 从 paperConfig（选题配置快照）取出全部 AI 题型进行补偿重生成
            if (!types.length && this.paperInfo && (this.paperInfo.paperStatus === 5 || this.paperInfo.paperStatus === '生成异常')) {
                const cfg = this.parsePaperConfig(this.paperInfo.paperConfig)
                if (cfg && cfg.selectedTypes && cfg.selectedTypes.length) {
                    types = cfg.selectedTypes
                        .map(t => (typeof t === 'object' ? t.type : t))
                        .filter(code => code !== undefined && code >= 3)
                }
            }
            if (!types.length) {
                this.$message.warning('无法识别缺失题型，请手动重试')
                return
            }

            this.regenerating = true
            try {
                const res = await regeneratePaperTypes(this.paperId, types)
                const data = res.data !== undefined ? res.data : res
                if (data && data.code !== undefined && data.code !== 200) {
                    this.$message.error(data.message || '重新生成失败')
                    return
                }
                const added = (data && data.data !== undefined) ? data.data : data
                this.$message.success(`已重新生成 ${added || 0} 道题目`)
                // 重新加载试卷内容，刷新题型分布与缺失提示
                await this.loadPaperContent()
            } catch (error) {
                console.error('重新生成缺失题型失败:', error)
                this.$message.error('重新生成失败，请稍后重试')
            } finally {
                this.regenerating = false
            }
        },

        // 解析 JSON 数组
        parseJsonArr(str) {
            if (!str) return []
            if (Array.isArray(str)) return str
            try { const v = JSON.parse(str); return Array.isArray(v) ? v : [] } catch { return [] }
        },
        // 解析试卷配置快照 paperConfig（JSON），兜底补偿时用于还原选题题型
        parsePaperConfig(str) {
            if (!str) return null
            try {
                const v = typeof str === 'string' ? JSON.parse(str) : str
                return v && typeof v === 'object' ? v : null
            } catch (e) {
                return null
            }
        },
        // 从 missing_info(JSON) 解析结构化缺失明细，用于详情页告警区展示
        parseMissingInfo(missingInfo) {
            if (!missingInfo) return []
            try {
                const info = typeof missingInfo === 'string' ? JSON.parse(missingInfo) : missingInfo
                if (!info || !info.hasMissing || !info.items) return []
                return info.items.map(it => ({
                    questionType: it.questionType,
                    typeName: it.typeName,
                    target: it.target,
                    actual: it.actual,
                    missingCount: it.missingCount,
                    reason: it.reason
                }))
            } catch (e) {
                return []
            }
        },
        // 计算题型百分比
        getQuestionPercentage(count) {
            return this.totalQuestions > 0 ? Math.round((count / this.totalQuestions) * 100) : 0
        },

        // 返回列表
        goBack() {
            this.$router.back()
        },

        // 下载试卷
        async downloadPaper() {
            try {
                const blob = await downloadPaperStream(this.paperId)
                const url = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = this.paperId + '.docx'
                document.body.appendChild(a)
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
            } catch (e) {
                this.$message.error('下载失败：' + (e.message || '未知错误'))
            }
        },

        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                0: '生成中',
                1: '已生成',
                2: '生成失败',
                3: '批改中',
                4: '已批改',
                5: '生成异常'
            }
            // 兼容字符串状态（来自 content 接口的 paperStatus 是文字描述）
            if (typeof status === 'string') return status
            return statusMap[status] || '未知'
        },

        // 获取状态类型
        getStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'success',
                2: 'danger',
                3: 'warning',
                4: 'primary',
                5: 'warning'
            }
            // 兼容字符串状态
            if (typeof status === 'string') {
                const textMap = {
                    '生成中': 'info',
                    '已生成': 'success',
                    '生成失败': 'danger',
                    '批改中': 'warning',
                    '已批改': 'primary',
                    '生成异常': 'warning'
                }
                return textMap[status] || ''
            }
            return typeMap[status] || ''
        }
    }
}
</script>

<style scoped lang="scss">
.paper-detail-container {
    padding: 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;

    .header-card {
        margin-bottom: 20px;
        border-radius: 12px;
        overflow: hidden;

        .header-content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;

            .header-left {
                display: flex;
                align-items: center;
                gap: 20px;

                .title-section {
                    .page-title {
                        margin: 0;
                        font-size: 28px;
                        font-weight: 700;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                    }

                    .subtitle {
                        margin: 5px 0 0 0;
                        font-size: 12px;
                        color: #909399;
                        letter-spacing: 1px;
                    }
                }
            }

            .header-right {
                display: flex;
                align-items: center;
                gap: 15px;
            }
        }
    }

    .loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;

        .loading-spinner {
            text-align: center;

            i {
                font-size: 48px;
                color: #409eff;
                animation: spin 1s linear infinite;
            }

            p {
                margin-top: 20px;
                font-size: 16px;
                color: #606266;
            }
        }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .detail-content {
        .info-row {
            margin-bottom: 20px;
        }

        .info-card,
        .stats-card,
        .question-types-card,
        .content-card {
            border-radius: 12px;
            margin-bottom: 20px;
            border: none;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            transition: all 0.3s ease;

            &:hover {
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
                transform: translateY(-2px);
            }

            .card-header {
                display: flex;
                align-items: center;
                gap: 10px;
                font-size: 18px;
                font-weight: 600;
                color: #303133;

                i {
                    font-size: 22px;
                    color: #409eff;
                }

                .header-badge {
                    margin-left: auto;
                    padding: 4px 12px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: #fff;
                    border-radius: 12px;
                    font-size: 12px;
                    font-weight: 500;
                }
            }
        }

        .stats-card {
            .stats-grid {
                display: grid;
                grid-template-columns: 1fr;
                gap: 15px;

                .stat-item {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    padding: 15px;
                    background: #f5f7fa;
                    border-radius: 10px;
                    transition: all 0.3s ease;

                    &:hover {
                        background: #e8ecf1;
                        transform: scale(1.02);
                    }

                    .stat-icon {
                        width: 50px;
                        height: 50px;
                        border-radius: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #fff;
                        font-size: 24px;
                        flex-shrink: 0;
                    }

                    .stat-info {
                        flex: 1;

                        .stat-label {
                            font-size: 12px;
                            color: #909399;
                            margin-bottom: 5px;
                        }

                        .stat-value {
                            font-size: 24px;
                            font-weight: 700;
                            color: #303133;

                            &.score-highlight {
                                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                                -webkit-background-clip: text;
                                -webkit-text-fill-color: transparent;
                                background-clip: text;
                            }
                        }
                    }
                }
            }
        }

        .question-types-card {
            .question-type-card {
                display: flex;
                align-items: center;
                gap: 15px;
                padding: 20px;
                background: #f5f7fa;
                border-radius: 10px;
                margin-bottom: 15px;
                transition: all 0.3s ease;

                &:hover {
                    background: #e8ecf1;
                    transform: translateX(5px);
                }

                .type-icon {
                    width: 50px;
                    height: 50px;
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 24px;
                    flex-shrink: 0;
                }

                .type-info {
                    flex: 1;

                    .type-name {
                        font-size: 16px;
                        font-weight: 600;
                        color: #303133;
                        margin-bottom: 5px;
                    }

                    .type-count {
                        font-size: 14px;
                        color: #606266;
                        margin-bottom: 8px;
                    }
                }
            }
        }

        .content-card {
            .vocabulary-table {
                .word-text {
                    font-weight: 600;
                    color: #409eff;
                    font-size: 15px;
                }

                .phonetic-text {
                    color: #909399;
                    font-family: 'Courier New', monospace;
                    font-size: 13px;
                }

                .meaning-text {
                    color: #606266;
                    font-size: 14px;
                }
            }

            .memo-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px;
            }

            .memo-grid-item {
                display: contents;
            }

            .memo-card {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 12px;
                background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%);
                border-radius: 8px;
                border: 1px solid transparent;
                transition: all 0.2s ease;

                &:hover {
                    border-color: #409eff;
                    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
                }

                .memo-front,
                .memo-back {
                    flex: 1;
                    padding: 10px;
                    background: #fff;
                    border-radius: 6px;
                    text-align: center;

                    .memo-content {
                        font-size: 14px;
                        font-weight: 600;
                        color: #303133;
                        word-break: break-all;
                    }
                }

                .memo-arrow {
                    flex-shrink: 0;
                    font-size: 18px;
                    color: #409eff;
                }
            }

            .sentence-item {
                display: flex;
                gap: 15px;
                padding: 20px;
                background: #f5f7fa;
                border-radius: 10px;
                margin-bottom: 15px;
                border-left: 4px solid #409eff;

                .sentence-number {
                    width: 40px;
                    height: 40px;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: #fff;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    font-size: 16px;
                    flex-shrink: 0;
                }

                .sentence-content {
                    flex: 1;

                    .sentence-en {
                        font-size: 16px;
                        font-weight: 500;
                        color: #303133;
                        margin-bottom: 8px;
                        line-height: 1.6;
                    }

                    .sentence-cn {
                        font-size: 14px;
                        color: #606266;
                        margin-bottom: 8px;
                        line-height: 1.6;
                    }

                    .sentence-analysis {
                        padding: 10px;
                        background: #fff;
                        border-radius: 6px;
                        font-size: 13px;
                        color: #909399;
                        line-height: 1.6;

                        i {
                            margin-right: 5px;
                            color: #e6a23c;
                        }
                    }
                }
            }

            .reading-item {
                margin-bottom: 30px;
                padding: 25px;
                background: #f5f7fa;
                border-radius: 12px;

                .reading-header {
                    margin-bottom: 20px;

                    h3 {
                        margin: 0;
                        font-size: 20px;
                        font-weight: 700;
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        background-clip: text;
                    }
                }

                .reading-content {
                    .article-section,
                    .translation-section,
                    .questions-section {
                        margin-bottom: 20px;

                        h4 {
                            font-size: 16px;
                            font-weight: 600;
                            color: #303133;
                            margin-bottom: 12px;
                            padding-bottom: 8px;
                            border-bottom: 2px solid #409eff;
                        }
                    }

                    .article-text {
                        padding: 15px;
                        background: #fff;
                        border-radius: 8px;
                        font-size: 15px;
                        line-height: 1.8;
                        color: #606266;

                        &.translation-text {
                            color: #909399;
                            font-style: italic;
                        }
                    }

                    .question-item {
                        padding: 20px;
                        background: #fff;
                        border-radius: 10px;
                        margin-bottom: 15px;
                        border-left: 4px solid #67c23a;

                        .question-header {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 12px;

                            .question-num {
                                font-weight: 700;
                                color: #67c23a;
                                font-size: 15px;
                            }
                        }

                        .question-text {
                            font-size: 15px;
                            color: #303133;
                            margin-bottom: 12px;
                            font-weight: 500;
                        }

                        .options-list {
                            margin-bottom: 12px;

                            .option-item {
                                padding: 10px 15px;
                                margin-bottom: 8px;
                                background: #f5f7fa;
                                border-radius: 6px;
                                display: flex;
                                align-items: center;
                                gap: 10px;
                                transition: all 0.2s ease;

                                &.correct-option {
                                    background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
                                    border: 2px solid #67c23a;

                                    .option-label {
                                        color: #67c23a;
                                        font-weight: 700;
                                    }

                                    .correct-icon {
                                        margin-left: auto;
                                        color: #67c23a;
                                        font-size: 18px;
                                    }
                                }

                                .option-label {
                                    font-weight: 600;
                                    color: #409eff;
                                    min-width: 20px;
                                }

                                .option-content {
                                    flex: 1;
                                    color: #606266;
                                }
                            }
                        }

                        .question-analysis {
                            padding: 12px;
                            background: #fff3e0;
                            border-radius: 6px;
                            font-size: 14px;
                            color: #e6a23c;
                            line-height: 1.6;

                            i {
                                margin-right: 5px;
                            }
                        }
                    }
                }
            }

            .good-word-item {
                padding: 24px;
                background: linear-gradient(135deg, #fffbeb 0%, #fff8e1 100%);
                border-radius: 12px;
                margin-bottom: 16px;
                border: 1px solid #ffeeba;
                transition: all 0.3s ease;

                &:hover {
                    box-shadow: 0 4px 16px rgba(250, 204, 21, 0.2);
                    transform: translateY(-2px);
                }

                .good-word-header {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    margin-bottom: 16px;
                    padding-bottom: 12px;
                    border-bottom: 2px dashed #ffeeba;

                    .header-icon {
                        font-size: 20px;
                        color: #f7b731;
                    }

                    .good-word-label {
                        font-size: 16px;
                        font-weight: 700;
                        color: #e6a23c;
                    }
                }

                .good-word-body {
                    .gw-row {
                        margin-bottom: 14px;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .gw-label {
                            display: inline-block;
                            font-size: 11px;
                            font-weight: 600;
                            color: #b8860b;
                            background: #fff3cd;
                            padding: 2px 10px;
                            border-radius: 10px;
                            margin-bottom: 8px;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                        }

                        .gw-text {
                            font-size: 15px;
                            line-height: 1.8;
                            padding: 12px 16px;
                            background: #fff;
                            border-radius: 8px;

                            &.gw-en {
                                font-weight: 500;
                                color: #303133;
                                font-style: italic;
                                border-left: 4px solid #f7b731;
                            }

                            &.gw-cn {
                                color: #606266;
                            }
                        }

                        .gw-analysis {
                            padding: 12px 16px;
                            background: #fff;
                            border-radius: 8px;
                            font-size: 14px;
                            color: #8a6d3b;
                            line-height: 1.7;
                            border-left: 4px solid #17a2b8;
                        }
                    }
                }
            }
        }
    }
}

// 选词填空 & 短文填空 & 完形填空
.fill-section, .cloze-section {
    margin-bottom: 24px;
    padding: 20px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #ebeef5;

    .fill-header, .cloze-header {
        margin-bottom: 16px;

        h4 {
            margin: 0 0 8px 0;
            font-size: 16px;
            color: #303133;
        }
    }

    .word-box {
        margin-bottom: 16px;
        padding: 12px 16px;
        background: #fffbe6;
        border: 1px dashed #e6a23c;
        border-radius: 8px;

        .word-box-label {
            display: block;
            margin-bottom: 8px;
            font-size: 13px;
            color: #856404;
        }

        .word-box-tags {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .word-box-tag {
                font-size: 14px;
                padding: 4px 12px;
            }
        }
    }

    .fill-passage, .cloze-passage {
        margin-bottom: 16px;

        .passage-text {
            padding: 16px;
            background: #fff;
            border-radius: 8px;
            font-size: 15px;
            line-height: 2;
            color: #303133;
            white-space: pre-wrap;
        }
    }

    .fill-answers, .dialogue-answers {
        margin-bottom: 16px;
        padding: 12px 16px;
        background: #f0f9eb;
        border-radius: 8px;

        h4 {
            margin: 0 0 10px 0;
            font-size: 14px;
            color: #303133;
        }

        .answer-item {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 6px 0;
            border-bottom: 1px dashed #e8e8e8;

            &:last-child { border-bottom: none; }

            .answer-blank {
                font-weight: 600;
                color: #606266;
                min-width: 60px;
            }

            .answer-base {
                color: #909399;
                font-size: 13px;
                text-decoration: line-through;
            }

            .answer-analysis {
                font-size: 13px;
                color: #606266;
            }
        }
    }

    .fill-translation {
        margin-top: 12px;
        padding: 12px 16px;
        background: #f0f5ff;
        border-radius: 8px;

        h4 {
            margin: 0 0 8px 0;
            font-size: 14px;
            color: #303133;
        }

        .translation-text {
            font-size: 14px;
            color: #606266;
            line-height: 1.8;
        }
    }
}

// 短文填空 - 提示表格
.blanks-table {
    margin-bottom: 16px;

    h4 {
        margin: 0 0 10px 0;
        font-size: 14px;
        color: #303133;
    }
}

// 任务型阅读
.task-section {
    margin: 16px 0;
    padding: 16px;
    background: #f0f5ff;
    border-radius: 8px;

    .task-header {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 12px;

        .task-instruction {
            font-size: 14px;
            color: #303133;
        }
    }

    .task-list {
        .task-item {
            padding: 10px 0;
            border-bottom: 1px dashed #e8e8e8;

            &:last-child { border-bottom: none; }

            .task-question {
                margin-bottom: 6px;
                font-size: 14px;
                line-height: 1.6;

                .task-num {
                    font-weight: 600;
                    color: #409eff;
                }
            }

            .task-answer {
                display: flex;
                align-items: center;
                gap: 8px;

                .task-answer-label {
                    font-size: 13px;
                    color: #909399;
                }

                .task-constraint {
                    font-size: 12px;
                    color: #909399;
                }
            }
        }
    }
}

// 完形填空 - 题目选项
.cloze-question-item {
    margin-bottom: 16px;
    padding: 12px 16px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #ebeef5;

    .cloze-q-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 8px;

        .cloze-q-num {
            font-weight: 600;
            font-size: 15px;
            color: #409eff;
        }
    }

    .cloze-options {
        .cloze-option {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 6px 10px;
            margin: 4px 0;
            border-radius: 4px;
            font-size: 14px;

            &.correct-option {
                background: #f0f9eb;
            }

            .cloze-opt-label {
                font-weight: 600;
                color: #606266;
                min-width: 24px;
            }
        }
    }

    .question-analysis {
        margin-top: 8px;
        padding: 8px 12px;
        background: #fff7e6;
        border-radius: 4px;
        font-size: 13px;
        color: #8a6d3b;
        line-height: 1.6;
    }
}

// 补全对话
.dialogue-section {
    margin-bottom: 24px;
    padding: 20px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #ebeef5;

    .dialogue-header {
        margin-bottom: 16px;

        h4 {
            margin: 0 0 8px 0;
            font-size: 16px;
            color: #303133;
        }
    }

    .dialogue-lines {
        margin-bottom: 16px;

        .dialogue-line {
            padding: 8px 12px;
            margin: 4px 0;
            background: #fff;
            border-radius: 6px;
            font-size: 14px;
            line-height: 1.6;

            .dialogue-speaker {
                font-weight: 600;
                color: #409eff;
                margin-right: 8px;
            }

            .dialogue-text {
                color: #303133;
            }
        }
    }

    .dialogue-options-section {
        margin-bottom: 16px;

        h4 {
            margin: 0 0 10px 0;
            font-size: 14px;
            color: #303133;
        }

        .dialogue-options {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .dialogue-opt-item {
                padding: 6px 14px;
                background: #fff;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                font-size: 14px;

                .dialogue-opt-label {
                    font-weight: 600;
                    color: #606266;
                }
            }
        }

        .dialogue-extra {
            margin-top: 8px;
        }
    }
}

// 响应式设计
@media (max-width: 768px) {
    .paper-detail-container {
        padding: 10px;

        .header-card .header-content {
            flex-direction: column;
            gap: 15px;

            .header-left,
            .header-right {
                width: 100%;
                justify-content: center;
            }
        }

        .stats-card .stats-grid {
            grid-template-columns: repeat(2, 1fr);
        }

        .question-types-card .question-type-card {
            flex-direction: column;
            text-align: center;
        }

        .question-types-nav {
            transition: all 0.3s ease;
            &.is-sticky {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                z-index: 1000;
                padding: 8px 24px;
                background: rgba(255,255,255,0.95);
                backdrop-filter: blur(8px);
                box-shadow: 0 4px 20px rgba(0,0,0,0.12);
                .question-types-card {
                    margin-bottom: 0;
                    box-shadow: none;
                    background: transparent;
                }
            }
        }

        .question-type-card {
            cursor: pointer;
            &.type-active {
                background: linear-gradient(135deg, #e8ecf1 0%, #d5dce6 100%) !important;
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            }
        }
    }
}

/* 生成缺失题型提示条（方案C） */
.missing-types-alert {
    margin-bottom: 16px;
    border-radius: 8px;

    .missing-alert-title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        line-height: 1.8;
    }

    .missing-tag {
        margin-left: 2px;
    }

    .missing-regenerate-btn {
        margin-left: auto;
    }

    .missing-alert-detail {
        margin-top: 8px;
        font-size: 13px;
        line-height: 1.8;
        color: #8a6d3b;

        .missing-detail-item {
            margin-bottom: 2px;
        }

        .missing-reason {
            display: block;
            color: #a08a5a;
            font-size: 12px;
        }
    }
}
</style>
